import { render, staticRenderFns } from "./attributes.vue?vue&type=template&id=ccbea2b4&scoped=true"
import script from "./attributes.vue?vue&type=script&lang=js"
export * from "./attributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbea2b4",
  null
  
)

export default component.exports